export const LockTypes = {
  USER: 'USER',
  KYC: 'KYC',
} as const;
export type LockType = keyof typeof LockTypes;

export type LockContextType = {
  busRelMasterNumber: string;
  userId: string;
};

export type PartnerLockType = { partnerUid: string; lockType: LockType; lockContext: LockContextType } | null;
